module.exports = __webpack_public_path__ + "media/svg/mp-0c771c14.svg";